function syncFuncsMap () {
    const map = {
        android: this.syncGoogle,
        google: this.syncGoogle,
        outlook: this.syncOutlook,
        office365: this.syncOutlook,
        windowslive: this.syncOutlook,
    };
    return map;
}

export default syncFuncsMap;
